import { Injectable } from '@angular/core';
import { HttpClient,  HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class RespuestasRapidasService {
  url = environment.urlWhats;
  constructor(private http: HttpClient) { }



  getAllRespuestas(idAdmin, id, role, token, urlBack){
    const headers = new HttpHeaders()
    .set('rol-token', token);
    return this.http.get(`${urlBack}/obtenerRespuestaRapida/${idAdmin}/${id}/${role}?ad_planIt=true`, {headers});

  }


  agregarRespuesta(data, id, role, token, urlBack){
    const headers = new HttpHeaders()
    .set('rol-token', token);
    return this.http.post(`${urlBack}/agregarRespuestaRapida/${id}/${role}?ad_planIt=true`, data, {headers});

  }

  borrarRespuesta(idAdmin, idRespuesta, id, role, token, urlBack){
    const headers = new HttpHeaders()
    .set('rol-token', token);
    return this.http.delete(`${urlBack}/eliminarRespuestaRapida/${idAdmin}/${idRespuesta}/${id}/${role}?ad_planIt=true`, {headers});

  }

  editarRespuesta(data, idRespuesta, id, role, token, urlBack){
    const headers = new HttpHeaders()
    .set('rol-token', token);
    return this.http.put(`${urlBack}/actualizarRespuestaRapida/${idRespuesta}/${id}/${role}?ad_planIt=true`, data, {headers});

  }


  // ---------------APARTADO DE SERVICIOS DE ENCUESTAS --------------
  consultaEnvios(idAdmin, id, role, token, query, urlBack){
    const headers = new HttpHeaders()
    .set('rol-token', token);
    return this.http.get(`${urlBack}/encuestas/consultaEnvios/${idAdmin}/${id}/${role}?ad_planIt=true${query}`, {headers});
  }

  consultaReportesEncuestas(idAdmin, id, role, token, query, urlBack){
    const headers = new HttpHeaders()
    .set('rol-token', token);
    return this.http.get(`${urlBack}/encuestas/reportesEncuestas/${idAdmin}/${id}/${role}?ad_planIt=true${query}`, {headers});
  }

  resultadoEncuestas(idAdmin, id, role, token, unique, urlBack){
    const headers = new HttpHeaders()
    .set('rol-token', token);
    return this.http.get(`${urlBack}/encuestas/resultadoEncuestas/${idAdmin}/${unique}/${id}/${role}?ad_planIt=true`, {headers});
  }

    agregarMultimedia(data, id, role, token, urlBack, numero) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    const url = `${urlBack}/multimedia-resp-rapidas/${numero}/${id}/${role}/${token}`;

    return this.http.post(url, data, { headers });
  }

}

